<template>
  <div class="loanSupeermarketBox">
    <div class="condition">
      <div class="conditionCenter">
          <div class="conditionCenter_title_header">
          <div class="conditionCenter_title">专属贷款方案</div>
          <div v-if="isShowOpen" class="arrowOpen" @click="arrowOpen">
            {{ isOpen ? '收起' : '展开'}}
            <van-icon :name="isOpen ? 'arrow-up' : 'arrow-down'" />
          </div>
        </div>
        <div class="conditionCenter_title_content" ref="content" :style="{height: slefHeight, overflow: ishide}">
          <div class="conditionListItem" v-for="(item, index) in conditionList" :key="index">{{ item.dictName === item.dictTypeName ? `${item.dictTypeName}` : item.dictTypeName === '地区' ? `${item.dictName}` :  `${item.dictTypeName}${item.dictName}`}}</div>
          <div class="conditionListItem" v-for="(e, index) in productHighlight" :key="index">{{ e }}</div>
        </div>
      </div>
    </div>
    <div class="loanScheme">
      <div class="title">产品信息</div>
      <div class="tip">满足上述条件的可申请产品</div>
    </div>
    <!-- 产品详情的 -->
    <div class="productList">
      <product-list
        ref="productListRef"
        @changeShowModal="changeShowModal"
      ></product-list>
    </div>
    <FloatingWindow></FloatingWindow>
  </div>
</template>
<script>
import FloatingWindow from '@/components/FloatingWindow.vue';
import ProductList from './components/ProductList.vue';

export default {
  name: 'loanSupermarket',
  data() {
    return {
      showModal: false,
      address: '',
      slefHeight: '',
      ishide: '',
      districtId: '',
      isOpen: true,
      isShowOpen: true,
      conditionList: [],
      productHighlight: [],
    };
  },
  created() {
  },
  mounted() {
    this.loadData();
  },
  components: {
    ProductList,
    FloatingWindow,
  },
  methods: {
    loadData() {
      this.$api.LoanSupermarket.queryFilterCondition({
        sfparam: this.$route.query.k || '',
      }).then((res) => {
        if (res.success) {
          this.conditionList = res.data.filter((e) => e.dictTypeName !== '产品亮点');
          if (res.data.filter((e) => e.dictTypeName === '产品亮点').length) {
            const { dictName } = res.data.filter((e) => e.dictTypeName === '产品亮点')[0];
            this.productHighlight = dictName.split(',');
          }
          this.$nextTick(() => {
            const height = this.$refs.content.offsetHeight;
            console.log('height', height);

            if (height > 100) {
              this.slefHeight = '88px';
              this.ishide = 'hidden';
              this.isOpen = false;
            } else {
              this.isShowOpen = false;
            }
          });
        } else {
          this.conditionList = [];
        }
        console.log(res, '???????');
      });
    },
    arrowOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.slefHeight = 'auto';
        this.ishide = 'none';
      } else {
        this.slefHeight = '88px';
        this.ishide = 'hidden';
      }
    },
    closeme() {
      this.showModal = false;
    },
    changeShowModal(flag) {
      this.showModal = flag;
    },
  },
};
</script>
<style lang="scss" scoped>
.arrowOpen{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #367EE8;
}
.condition{
  background: #F0F8FF;
  min-height: 156px;
  .conditionCenter{
    margin: 16px;
    border-radius: 8px;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.15);
    background-color: #fff;
    .conditionCenter_title_header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 13px 12px;
    }
    .conditionCenter_title_content{
      padding: 0 12px 12px 12px;
      display: flex;
      flex-wrap: wrap;
    }
    .conditionListItem{
      padding: 3px 16px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      height: 20px;
      color: #367EE8;
      font-weight: 400;
      background: #F0F8FF;
      border-radius: 4px;
      margin: 0 8px 8px 0;
    }
    .conditionCenter_title{
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2F3133;
      font-weight: 600;
    }
  }
}
.loanScheme{
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  .title{
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #2F3133;
    line-height: 42px;
    font-weight: 600;
    margin: 0 8px 0 15px;
  }
  .tip{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #BCC2CC;
    line-height: 36px;
    font-weight: 400;
  }
}
</style>
